import { memo, useEffect, useState } from "react";
import notifyIcon from "../../../assets/images/sms-tracking.svg";
import styles from "./Card.module.scss";

const Card = ({ user, onClick, isClass, isUnregisterLoading = false, handleNotifyUser = async () => { } }) => {
  const { fullName, email, _id, isParticipant, notified } = user;
  const [isLoading, setIsLoading] = useState(false);
  const isParticipantInClass = Boolean(isClass && isParticipant);

  useEffect(() => {
    if(notified){
      setIsLoading(false);
    }
  }, [notified])

  const notifyUser = async (_id) => {
    setIsLoading(true);
    await handleNotifyUser(_id);
  }
  return (
    <div className={`${styles.userItemBox} ${isClass ? styles.class : ""}`}>
      <div className={styles.userNameBox}>{fullName || "no fullName"}</div>
      <div className={styles.userEmailBox}>{email || "no email"}</div>
      {isParticipantInClass && (
        <button
          type="button"
          className={styles.notify}
          onClick={() => notifyUser(_id)}
          disabled={notified || isLoading}>
          {isLoading ? (
            <div className={styles.loaderContainer}>
              <div className={styles.loader}></div>
            </div>
          ) : (
            <>
              <img src={notifyIcon} alt="Notify Icon" className={styles.notifyIcon} />
              <span>Notify</span>
            </>
          )}
        </button>
      )}
      <div className={`${styles.buttonClass} ${isClass && !isParticipant ? styles.notParticipant : ""}`} onClick={() => onClick(_id)}>
        {isUnregisterLoading ? (
          <div className={styles.loaderContainer}>
            <div className={styles.loader}></div>
          </div>
        ) : (
          "Unregister"
        )}
      </div>
    </div>
  );
};

export default memo(Card);